import { capitalize } from "util/format"

export const vehicleTypes = [
  { type: 'Car', icon: 'vehicle-car' },
  { type: 'SUV', icon: 'vehicle-suv' },
  { type: 'Van', icon: 'vehicle-van' },
  { type: 'Pickup', icon: 'vehicle-pickup' },
  { type: 'Truck', icon: 'vehicle-truck' },
]

export const vehicleColors = [
  { label: 'grey', hex: '#7A7A7A' },
  { label: 'black', hex: 'black' },
  { label: 'white', hex: 'white' },
  { label: 'blue', hex: '#2054cf' },
  { label: 'red', hex: '#e34025' },
  { label: 'silver', hex: '#D2D2D2' },
  { label: 'green', hex: '#508630' },
  { label: 'orange', hex: '#ff9900' },
  { label: 'brown', hex: '#814d00' },
  { label: 'purple', hex: '#680cb8' },
  { label: 'yellow', hex: '#fedc89' },
  { label: 'beige', hex: '#f5f5dc' },
]

export const vehicleCategories = [
  'two_door',             // 0
  'sedan',                // 1
  'hatchback_suv',        // 2
  'van',                  // 3
  'pickup_truck',         // 4
  'box_truck',            // 5
  'cargo_van',            // 6
  'large_box_truck',      // 7
  'oversized_box_truck',  // 8
]

export function getCategoryByEnumVal(enumVal) {
  return vehicleCategories[enumVal]
}

export const vehicleSubTypes = {
  Car: [
    {
      name: 'Compact Car',
      desc: 'Honda Civic, Ford Focus, VW Jetta, etc.',
      enumVal: 0,
      make: 'Compact',
      model: 'Car',
    },
    {
      name: 'Full-Sized Car',
      desc: 'Honda Accord, Chevy Malibu, Chrysler 300, etc.',
      enumVal: 1,
      make: 'Full-Sized',
      model: 'Car'
    },
    {
      name: 'Hatchback',
      desc: 'VW Golf, Toyota Prius, Honda Civic Hatchback, etc.',
      enumVal: 2,
      make: null,
      model: 'Hatchback',
    }
  ],
  SUV: [
    {
      name: 'Compact SUV',
      desc: 'Honda CRV, Mazda CX-5, Toyota RAV4, etc.',
      enumVal: 2,
      make: 'Compact',
      model: 'SUV',
    },
    {
      name: 'Large SUV',
      desc: 'Ford Expedition, GMC Yukon, Toyota Sequoia, etc.',
      enumVal: 3,
      make: 'Large',
      model: 'SUV',
    }
  ],
  Van: [
    {
      name: 'Minivan',
      desc: 'Toyota Sienna, Honda Odyssey, etc.',
      enumVal: 3,
      make: null,
      model: 'Minivan',

    },
    {
      name: 'Cargo Van',
      desc: 'Ford Transit, Chevy Express, Nissan NV, etc.',
      enumVal: 5,
      make: 'Cargo',
      model: 'Van',
    },
  ],
  Pickup: [
    {
      name: 'Short Bed Pickup',
      desc: 'Less than 6 ft of bed length',
      enumVal: 2,
      make: 'Short Bed',
      model: 'Pickup',
    },
    {
      name: 'Standard Bed Pickup',
      desc: '6-7 ft of bed length',
      enumVal: 3,
      make: 'Standard Bed',
      model: 'Pickup',
    },
    {
      name: 'Long Bed Pickup',
      desc: 'More than 7 ft of bed length',
      enumVal: 4,
      make: 'Long Bed',
      model: 'Pickup',
    }
  ],
  Truck: [
    {
      name: 'Small Box Truck',
      desc: '12-15 ft',
      enumVal: 6,
      make: 'Small',
      model: 'Box Truck',
    },
    {
      name: 'Medium Box Truck',
      desc: '16-25 ft',
      enumVal: 7,
      make: 'Medium',
      model: 'Box Truck',
    },
    {
      name: 'Large Box Truck',
      desc: '26+ ft',
      enumVal: 8,
      make: 'Large',
      model: 'Box Truck',
    }
  ],
}

export function getVehicleString(color, make, model) {
  const makePart = make ? `${make} ` : ''
  return `${capitalize(color)} ${makePart}${model}`
}
